import React from "react";
import "./SquareIcon.scss";

const SquareIcon = ({
  squareFirstClassname,
  squareSecondClassname,
  imgSrc,
}) => {
  return (
    <div className="square_wrapp">
      <div className={`${"square_first"} ${squareFirstClassname}`}></div>
      <div className={`${"square_second"} ${squareSecondClassname}`}>
        <img src={imgSrc} alt="icon" />
      </div>
    </div>
  );
};

export default SquareIcon;
